package one.healthium.onboarding.domain.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class Slider(
    @SerialName("title") val title: String?,
    @SerialName("intervals") val intervals: List<SliderInterval>
)


@Serializable
data class SliderInterval(
    @SerialName("percentage") val percentage: Int,
    @SerialName("time_interval") val timeInterval: Int,
    @SerialName("popup_message") val popupMessage: String? = null,
    @SerialName("answers") val answers: List<String>? = null,
)